import { Link } from "react-router-dom";
import { ArrowRight, Globe, Layout, Heart, Sparkles, ShieldCheck, Zap } from "lucide-react";

export default function ChurchBuilderLanding() {
  return (
    <div data-testid="cb-landing" className="bg-[#0A0A0A] text-white">
      {/* HERO */}
      <section className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1438232992991-995b7058bbb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/70 to-[#0A0A0A]" />
        </div>
        <div className="relative max-w-6xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
          <div className="label-eyebrow flex items-center gap-2 mb-6"><Sparkles size={14} /> Church Builder · HOH Ministries Cloud</div>
          <h1 className="font-serif-display text-5xl lg:text-6xl leading-[1.05] max-w-3xl">
            Beautiful church websites <span className="italic text-[#D4AF37]">in minutes</span>.
          </h1>
          <p className="text-neutral-300 mt-6 max-w-2xl text-lg leading-relaxed">
            HOH Ministries Cloud is a multi-tenant website builder designed for churches and ministries. Pick a template, customise your content, publish — no developer needed.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/church-builder/register" data-testid="cb-hero-cta" className="btn-gold px-7 py-3 rounded inline-flex items-center gap-2 text-sm tracking-widest uppercase font-semibold">
              Start 7-day free trial <ArrowRight size={14} />
            </Link>
            <Link to="/church-builder/templates" data-testid="cb-hero-templates" className="btn-ghost-gold px-7 py-3 rounded inline-flex items-center gap-2 text-sm tracking-widest uppercase font-semibold">
              View Templates
            </Link>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-20">
        <div className="label-eyebrow mb-3">Why Church Builder</div>
        <h2 className="font-serif-display text-4xl lg:text-5xl">Everything a church needs, <span className="italic text-[#D4AF37]">nothing it doesn&apos;t</span>.</h2>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {[
            { icon: Layout, title: "Dynamic Templates", desc: "Three professionally designed templates with more on the way. Switch any time without losing content." },
            { icon: Heart, title: "Built for Ministry", desc: "Service times, departments, sermon library, livestream, prayer requests — purpose-built for church life." },
            { icon: ShieldCheck, title: "Multi-tenant & Secure", desc: "Role-based access for pastors, admins and editors. Each church's data is isolated." },
            { icon: Globe, title: "SEO Friendly", desc: "Server-rendered metadata, clean URLs, mobile-first." },
            { icon: Zap, title: "Publish in One Click", desc: "Preview, publish and unpublish from your dashboard. No deployment headaches." },
            { icon: Sparkles, title: "Modular Future", desc: "Donations, VerseDisplay, membership, mobile apps — plug in modules as you grow." },
          ].map((f) => (
            <div key={f.title} className="luxury-card rounded-xl p-6">
              <f.icon size={20} className="text-[#D4AF37]" />
              <div className="font-serif-display text-xl mt-4">{f.title}</div>
              <div className="text-sm text-neutral-400 mt-2 leading-relaxed">{f.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="border-t border-white/10 py-24 text-center">
        <div className="label-eyebrow mb-3 justify-center">Ready?</div>
        <h2 className="font-serif-display text-4xl lg:text-5xl">Get your church online <span className="italic text-[#D4AF37]">today</span>.</h2>
        <Link to="/church-builder/pricing" data-testid="cb-cta-pricing" className="btn-gold mt-10 inline-flex items-center gap-2 px-8 py-4 rounded text-sm tracking-widest uppercase font-semibold">
          See pricing <ArrowRight size={14} />
        </Link>
      </section>
    </div>
  );
}
